import { Environment } from '@coolblue-development/constants';
import { getServerRequestContext } from '@coolblue-development/next-request-context/server';
import { getDevelopmentOverrides } from '@coolblue-development/next-split-testing-utils';
import { areSplitTestsDisabled } from './areSplitTestsDisabled.js';
import { getCookies } from './getCookies.js';
export async function getAllAssignedVariations() {
    const cookies = await getCookies();
    if (areSplitTestsDisabled(cookies)) {
        return [];
    }
    const { splitTests, environment } = await getServerRequestContext();
    const isDevelopment = environment === Environment.DEVELOPMENT;
    if (isDevelopment) {
        return getDevelopmentOverrides(cookies);
    }
    return JSON.parse(splitTests || '[]');
}
//# sourceMappingURL=getAllAssignedVariations.js.map